import { render, staticRenderFns } from "./writeMessage1.vue?vue&type=template&id=6d8b9a5c&scoped=true"
import script from "./writeMessage1.vue?vue&type=script&lang=js"
export * from "./writeMessage1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8b9a5c",
  null
  
)

export default component.exports